import { render, staticRenderFns } from "./DigitalDocShortList.vue?vue&type=template&id=c041be08&scoped=true"
import script from "./DigitalDocShortList.vue?vue&type=script&lang=js"
export * from "./DigitalDocShortList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c041be08",
  null
  
)

export default component.exports